<template>
  <details
    :key="actionItem.fragmentType + actionItem.fragmentId"
    :open="open"
    @toggle="open = $event.target.open"
  >
    <summary>
      <div class="header-group action-details">
        <ts-tooltip :tooltip="actionItem.action" position="top">
          <ts-icon
            class="action-type-icon"
            :type="actionIcons[actionItem.action].iconType"
            :icon="actionIcons[actionItem.action].icon"
            size="large"
          />
        </ts-tooltip>
        <ts-icon
          class="detail-open-icon"
          icon="arrow-down-short"
          size="large"
          type="slate-lightest"
          :rotate="open ? null : '270'"
        />
        <ts-list-item
          class="fragment-info"
          :title.attr="`FragmentType: ${actionItem.fragmentType}`"
          :subtitle.attr="`FragmentId: ${actionItem.fragmentId}`"
        />
      </div>
      <div class="header-group action-state">
        <ts-checkbox
          @click.prevent="
            $emit('verify', { actionItem, verified: $event.target.checked })
          "
          :checked="actionItem.verified"
          data-label="Verify?"
          :readonly="isApplyingDeltaPlan"
        />
      </div>
    </summary>
    <div>
      <diff-viewer
        :old-string="formatConfig(actionItem.from)"
        :new-string="formatConfig(actionItem.to)"
        :context="1000"
        :output-format="outputFormat"
        no-change-message=""
        old-string-header="Current Configuration"
        new-string-header="New Configuration (Not applied yet!)"
      />
    </div>
  </details>
</template>

<script>
import '@tradeshift/elements.icon';
import '@tradeshift/elements.list-item';
import '@tradeshift/elements.tooltip';
import DiffViewer from '../../../Shared/DiffViewer';

const actionTypes = {
  UPDATE: 'Update',
  DELETE: 'Delete',
  ADD: 'Add',
};

export default {
  components: { DiffViewer },
  inject: ['configUpdateProvidedData'],
  props: {
    outputFormat: {
      type: String,
      default: 'side-by-side',
    },
    actionItem: {
      type: Object,
      default: () => ({
        fragmentType: '',
        fragmentId: '',
        action: '',
        from: '',
        to: '',
      }),
      required: true,
    },
  },
  emits: ['verify'],
  data() {
    return {
      actionIcons: {
        [actionTypes.ADD]: {
          icon: 'add',
          iconType: 'success',
        },
        [actionTypes.UPDATE]: {
          icon: 'edit',
          iconType: 'warning',
        },
        [actionTypes.DELETE]: {
          icon: 'delete',
          iconType: 'danger',
        },
      },
      open: true,
    };
  },
  computed: {
    isApplyingDeltaPlan() {
      return this.configUpdateProvidedData?.isApplyingDeltaPlan;
    },
  },
  methods: {
    formatConfig(config) {
      if (!config) {
        return '';
      }
      return JSON.stringify(config, null, 2);
    },
  },
};
</script>

<style scoped>
details {
  margin-bottom: var(--ts-unit);
}

summary {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  border: 1px var(--ts-color-gray-light);
  border-style: solid solid solid none;
}

.fragment-info {
  display: inline-block;
}

.header-group {
  position: relative;
  display: flex;
  align-items: stretch;
}

.header-group.action-state {
  align-items: center;
}

.header-group.action-details ts-tooltip {
  display: flex;
  align-items: center;
}

summary ts-checkbox {
  align-self: center;
  margin: 0 var(--ts-unit-half);
}

details summary::-webkit-details-marker,
details summary::marker {
  display: none;
  content: '';
}

.action-type-icon {
  padding: var(--ts-unit-quarter);
  padding-left: var(--ts-unit-half);
}

.action-type-icon:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border-left: var(--ts-unit-quarter) solid;
}

.action-type-icon[type='success']:before {
  background: var(--ts-color-green-lightest);
  border-left-color: var(--ts-color-green-dark);
}

.action-type-icon[type='warning']:before {
  background: var(--ts-color-orange-lightest);
  border-left-color: var(--ts-color-orange-dark);
}

.action-type-icon[type='danger']:before {
  background: var(--ts-color-red-lightest);
  border-left-color: var(--ts-color-red-dark);
}

.detail-open-icon {
  align-self: center;
  padding: 0 var(--ts-unit-half);
}
</style>
